import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { User, CalendarDays, ArrowLeft } from 'lucide-react';
import Navbar from '../../../../components/navbar/Navbar';
import Footer from '../../../../components/footer/Footer';
import LiveChat from '../../section-component/live-chat/LiveChat';
import { courseApi } from '../../../../api/api';
import api from '../../../../utils/api';
import SocialMediaPanel from '../../../../components/common/social-media/SocialMediaPanel';

const CourseDetails = () => {
    const [courseDetails, setCourseDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { id } = useParams();
    const navigate = useNavigate();

    //  Fetch course details from API
    useEffect(() => {
        const fetchCourseDetails = async () => {
            try {
                const response = await api.get(`${courseApi}/${id}`);
                setCourseDetails(response.data);
                setLoading(false);
            } catch (err) {
                setError("Course not found!");
                setLoading(false);
            }
        };

        fetchCourseDetails();
    }, [id]);

    if (loading) {
        return <div className="blog-details-error"><h2>Loading...</h2></div>;
    }

    if (error || !courseDetails) {
        return (
            <div className="blog-details-error">
                <h2 className="blog-details-error-title">{error || "Course not found!"}</h2>
                <button className="blog-details-back-btn" onClick={() => navigate(-1)}>
                    <ArrowLeft size={18} /> Go Back
                </button>
            </div>
        );
    }

    return (
        <>
            
 
            <div className="blog-details-wrapper">
                {/* Hero Section */}
                <div className="blog-details-hero">
                    <img src={courseDetails.image} alt={courseDetails.title} className="blog-details-hero-image" />
                    <div className="blog-details-hero-overlay"></div>
                    <div className="blog-details-hero-content">
                        <h1 className="blog-details-title">{courseDetails.title}</h1>
                        <div className="blog-details-meta">
                            {/* <span className="blog-details-meta-item">
                                <User size={18} /> {courseDetails.author}
                            </span> */}
                            <span className="blog-details-meta-item">
                                <CalendarDays size={18} /> {new Intl.DateTimeFormat('en-GB', {day: 'numeric', month: 'long', year: 'numeric'}).format(new Date(courseDetails.created_at))}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div className="blog-details-content-wrapper">
                    <div className="blog-details-content"
                        dangerouslySetInnerHTML={{ __html: courseDetails.long_description.replace(/<[^>]+>/g, "") }}
                    ></div>
                    <p className="blog-details-content">{courseDetails.content}</p>
                </div>
            </div>
            
            
        </>
    );
};

export default CourseDetails;
